/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Opencriticratingalt3Inputs */

const id_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat OpenCritic`)
};

const ms_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian OpenCritic`)
};

const da_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic Bedømmelse`)
};

const de_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic-Bewertung`)
};

const en_us2_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic Rating`)
};

const es_es2_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación de OpenCritic`)
};

const es_mx2_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación de OpenCritic`)
};

const fil_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating ng OpenCritic`)
};

const fr_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note OpenCritic`)
};

const it_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione OpenCritic`)
};

const hu_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic értékelés`)
};

const nl_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic-beoordeling`)
};

const no_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic-vurdering`)
};

const pl_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena OpenCritic`)
};

const pt_br2_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação OpenCritic`)
};

const pt_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação OpenCritic`)
};

const ro_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluare OpenCritic`)
};

const fi_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic-arvio`)
};

const sv_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic-betyg`)
};

const vi_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng OpenCritic`)
};

const tr_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic Puanı`)
};

const cs_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnocení OpenCritic`)
};

const bg_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic оценка`)
};

const ru_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг OpenCritic`)
};

const uk_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг OpenCritic`)
};

const ar_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقييم OpenCritic`)
};

const hi_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic रेटिंग`)
};

const th_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนน OpenCritic`)
};

const ja_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic レーティング`)
};

const zh_cn2_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic评分`)
};

const zh_hant1_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic評分`)
};

const ko_offerdetail_reviews_opencriticratingalt3 = /** @type {(inputs: Offerdetail_Reviews_Opencriticratingalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenCritic 평점`)
};

/**
* | output |
* | --- |
* | "OpenCritic Rating" |
*
* @param {Offerdetail_Reviews_Opencriticratingalt3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_opencriticratingalt3 = /** @type {((inputs?: Offerdetail_Reviews_Opencriticratingalt3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Opencriticratingalt3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "da") return da_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "de") return de_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "it") return it_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "no") return no_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "th") return th_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_opencriticratingalt3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_opencriticratingalt3(inputs)
	return ko_offerdetail_reviews_opencriticratingalt3(inputs)
});
export { offerdetail_reviews_opencriticratingalt3 as "offerDetail.reviews.opencriticRatingAlt" }